const coordinates = [
  {lng: 106.7301699, lat: 10.8195918},
  {lng: 106.7251918, lat: 10.8166832},
  {lng: 106.7217156, lat: 10.8097279},
  {lng: 106.7228314, lat: 10.8042057},
  {lng: 106.7142483, lat: 10.8031097},
  {lng: 106.7113301, lat: 10.8013392},
  {lng: 106.7102572, lat: 10.7961119},
  {lng: 106.7062232, lat: 10.7915169},
  {lng: 106.7089698, lat: 10.7867111},
  {lng: 106.7060515, lat: 10.7823267},
  {lng: 106.7106005, lat: 10.7791227},
  {lng: 106.7084977, lat: 10.7751598},
  {lng: 106.7088839, lat: 10.7702272},
  {lng: 106.7117163, lat: 10.764367},
  {lng: 106.7171666, lat: 10.7615001},
  {lng: 106.7250201, lat: 10.7597294},
  {lng: 106.7309853, lat: 10.7609099},
  {lng: 106.7338177, lat: 10.7659691},
  {lng: 106.7329594, lat: 10.7721665},
  {lng: 106.7351481, lat: 10.7766775},
  {lng: 106.740298, lat: 10.7787433},
  {lng: 106.7472502, lat: 10.7759608},
  {lng: 106.7512843, lat: 10.7716185},
  {lng: 106.7523142, lat: 10.770691},
  {lng: 106.7585798, lat: 10.7775207},
  {lng: 106.7535587, lat: 10.7833385},
  {lng: 106.7519279, lat: 10.7847297},
  {lng: 106.7547174, lat: 10.7855307},
  {lng: 106.7540308, lat: 10.7879336},
  {lng: 106.7545887, lat: 10.7889454},
  {lng: 106.7556616, lat: 10.7897042},
  {lng: 106.756434, lat: 10.7913062},
  {lng: 106.7572065, lat: 10.7921914},
  {lng: 106.7584081, lat: 10.7924444},
  {lng: 106.7595239, lat: 10.7908003},
  {lng: 106.7608543, lat: 10.7902944},
  {lng: 106.7621418, lat: 10.7897042},
  {lng: 106.7631717, lat: 10.7898307},
  {lng: 106.7639442, lat: 10.7900836},
  {lng: 106.764545, lat: 10.7909689},
  {lng: 106.7649742, lat: 10.7916434},
  {lng: 106.76506, lat: 10.7930767},
  {lng: 106.7650171, lat: 10.7944679},
  {lng: 106.7648025, lat: 10.7984305},
  {lng: 106.7646738, lat: 10.8004961},
  {lng: 106.7652317, lat: 10.8022666},
  {lng: 106.7676349, lat: 10.8038685},
  {lng: 106.767592, lat: 10.8074938},
  {lng: 106.767592, lat: 10.8083369},
  {lng: 106.7654033, lat: 10.8088006},
  {lng: 106.7642446, lat: 10.8101916},
  {lng: 106.7639871, lat: 10.8121307},
  {lng: 106.7629142, lat: 10.8141541},
  {lng: 106.7612835, lat: 10.8145756},
  {lng: 106.758966, lat: 10.8137325},
  {lng: 106.7575927, lat: 10.8131424},
  {lng: 106.7551895, lat: 10.8132688},
  {lng: 106.7526575, lat: 10.8131845},
  {lng: 106.7501256, lat: 10.8113719},
  {lng: 106.7484948, lat: 10.8095593},
  {lng: 106.7456195, lat: 10.8085055},
  {lng: 106.742315, lat: 10.8085898},
  {lng: 106.7404267, lat: 10.8095172},
  {lng: 106.7373368, lat: 10.811667},
  {lng: 106.7362639, lat: 10.8139854},
  {lng: 106.734719, lat: 10.8180321},
  {lng: 106.7301699, lat: 10.8195918},
];

module.exports = coordinates;



// WEBPACK FOOTER //
// ./src/map.js